import { render, staticRenderFns } from "./add_on.vue?vue&type=template&id=fb6d609a&v-if=numberOfAddOns%20%3E%200&"
import script from "./add_on.vue?vue&type=script&lang=js&"
export * from "./add_on.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports